// src/components/Support/StatusUpdateDialog.jsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,
  Box,
  Chip,
  Stack,
} from '@mui/material';
import { SUPPORT_STATUSES, getStatusConfig } from '../../constants/supportConstants';
import StatusBadge from './StatusBadge';

const StatusUpdateDialog = ({ open, ticket, onClose, onUpdate }) => {
  const [selectedStatus, setSelectedStatus] = useState(ticket?.status || 'open');
  const [note, setNote] = useState('');

  const handleUpdate = () => {
    onUpdate(ticket.id, selectedStatus, note);
    onClose();
  };

  if (!ticket) return null;

  const currentStatusConfig = getStatusConfig(ticket.status);
  const newStatusConfig = getStatusConfig(selectedStatus);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Update Ticket Status</Typography>
        <Typography variant="body2" color="text.secondary">
          {ticket.ticketNumber} - {ticket.subject}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" gutterBottom>
            Current Status
          </Typography>
          <StatusBadge status={ticket.status} size="medium" />
        </Box>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel>New Status</InputLabel>
          <Select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            label="New Status"
          >
            {SUPPORT_STATUSES.map((status) => (
              <MenuItem key={status.value} value={status.value}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <span>{status.icon}</span>
                  <Typography>{status.label}</Typography>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedStatus !== ticket.status && (
          <Box sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>
            <Typography variant="caption" display="block" color="warning.dark">
              Changing status from <strong>{currentStatusConfig.label}</strong> to{' '}
              <strong>{newStatusConfig.label}</strong>
            </Typography>
          </Box>
        )}

        <TextField
          fullWidth
          multiline
          rows={3}
          label="Note (optional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Add a note explaining the status change..."
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleUpdate}
          disabled={selectedStatus === ticket.status}
        >
          Update Status
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusUpdateDialog;